/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'clsx';
import type { ButtonHTMLAttributes } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import type { CTA } from '@swf/cms';
import RawButton from '@swf/components/StarsButton/RawButton';
import useTrackers from '@swf/core/hooks/useTrackers';
import { select } from '@swf/core/store';
import type { ClassNameProp } from '@swf/core/types/Props';
import { routeHandler } from '@swf/core/utils/c2l';

import styles from './CMSCTA.scss';

interface Props {
  space?: boolean;
  grow?: boolean;
}

const ButtonType = 'text';

const CMSCTA: React.FC<
  CTA & Partial<ClassNameProp> & ButtonHTMLAttributes<HTMLButtonElement> & Props
> = ({
  space = true,
  grow = false,
  title,
  url,
  children,
  rel,
  target,
  className,
  track_id,
  hard_refresh,
  ...rest
}) => {
  const history = useHistory();
  const localePrefix = useSelector(select.location.getLocaleURL);

  const { buttonPressed } = useTrackers();

  const onClick = (e: React.MouseEvent) => {
    if (track_id) {
      buttonPressed({ buttonName: track_id });
    }

    if (hard_refresh && url) {
      e.preventDefault();
      window.location.assign(`${localePrefix}${url}`);
    } else {
      routeHandler(url, history, e);
    }
  };

  return title ? (
    <div
      className={classNames(
        styles.container,
        space && styles.space,
        grow && styles.grow,
        className
      )}
    >
      <RawButton
        href={url}
        variant={ButtonType}
        rel={url ? rel || undefined : undefined}
        target={url ? target ?? undefined : undefined}
        className={styles.cta}
        onClick={(e: React.MouseEvent) => onClick(e)}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        {...(rest as any)}
      >
        {title || children}
      </RawButton>
    </div>
  ) : null;
};

export default CMSCTA;
